/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterArticleAddPost } from '../fn/article/api-master-article-add-post';
import { ApiMasterArticleAddPost$Params } from '../fn/article/api-master-article-add-post';
import { apiMasterArticleDeleteGet } from '../fn/article/api-master-article-delete-get';
import { ApiMasterArticleDeleteGet$Params } from '../fn/article/api-master-article-delete-get';
import { apiMasterArticleEditPost } from '../fn/article/api-master-article-edit-post';
import { ApiMasterArticleEditPost$Params } from '../fn/article/api-master-article-edit-post';
import { apiMasterArticleGetActiveGet } from '../fn/article/api-master-article-get-active-get';
import { ApiMasterArticleGetActiveGet$Params } from '../fn/article/api-master-article-get-active-get';
import { apiMasterArticleGetAllGet } from '../fn/article/api-master-article-get-all-get';
import { ApiMasterArticleGetAllGet$Params } from '../fn/article/api-master-article-get-all-get';
import { apiMasterArticleGetByCriteriaPost } from '../fn/article/api-master-article-get-by-criteria-post';
import { ApiMasterArticleGetByCriteriaPost$Params } from '../fn/article/api-master-article-get-by-criteria-post';
import { apiMasterArticleGetByIdGet } from '../fn/article/api-master-article-get-by-id-get';
import { ApiMasterArticleGetByIdGet$Params } from '../fn/article/api-master-article-get-by-id-get';
import { apiMasterArticleGetLastThreeGet } from '../fn/article/api-master-article-get-last-three-get';
import { ApiMasterArticleGetLastThreeGet$Params } from '../fn/article/api-master-article-get-last-three-get';
import { Article } from '../models/article';
import { ArticleApiRespModel } from '../models/article-api-resp-model';
import { StringApiRespModel } from '../models/string-api-resp-model';

@Injectable({ providedIn: 'root' })
export class ArticleService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterArticleAddPost()` */
  static readonly ApiMasterArticleAddPostPath = '/api/Master/Article/Add';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleAddPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterArticleAddPost$Response(params?: ApiMasterArticleAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleApiRespModel>> {
    return apiMasterArticleAddPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleAddPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterArticleAddPost(params?: ApiMasterArticleAddPost$Params, context?: HttpContext): Observable<ArticleApiRespModel> {
    return this.apiMasterArticleAddPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ArticleApiRespModel>): ArticleApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleEditPost()` */
  static readonly ApiMasterArticleEditPostPath = '/api/Master/Article/Edit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleEditPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterArticleEditPost$Response(params?: ApiMasterArticleEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ArticleApiRespModel>> {
    return apiMasterArticleEditPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleEditPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterArticleEditPost(params?: ApiMasterArticleEditPost$Params, context?: HttpContext): Observable<ArticleApiRespModel> {
    return this.apiMasterArticleEditPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ArticleApiRespModel>): ArticleApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleDeleteGet()` */
  static readonly ApiMasterArticleDeleteGetPath = '/api/Master/Article/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleDeleteGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleDeleteGet$Response(params?: ApiMasterArticleDeleteGet$Params, context?: HttpContext): Observable<StrictHttpResponse<StringApiRespModel>> {
    return apiMasterArticleDeleteGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleDeleteGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleDeleteGet(params?: ApiMasterArticleDeleteGet$Params, context?: HttpContext): Observable<StringApiRespModel> {
    return this.apiMasterArticleDeleteGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<StringApiRespModel>): StringApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleGetAllGet()` */
  static readonly ApiMasterArticleGetAllGetPath = '/api/Master/Article/GetAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleGetAllGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetAllGet$Response(params?: ApiMasterArticleGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Article>>> {
    return apiMasterArticleGetAllGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleGetAllGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetAllGet(params?: ApiMasterArticleGetAllGet$Params, context?: HttpContext): Observable<Array<Article>> {
    return this.apiMasterArticleGetAllGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Article>>): Array<Article> => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleGetActiveGet()` */
  static readonly ApiMasterArticleGetActiveGetPath = '/api/Master/Article/GetActive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleGetActiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetActiveGet$Response(params?: ApiMasterArticleGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Article>>> {
    return apiMasterArticleGetActiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleGetActiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetActiveGet(params?: ApiMasterArticleGetActiveGet$Params, context?: HttpContext): Observable<Array<Article>> {
    return this.apiMasterArticleGetActiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Article>>): Array<Article> => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleGetByCriteriaPost()` */
  static readonly ApiMasterArticleGetByCriteriaPostPath = '/api/Master/Article/GetByCriteria';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleGetByCriteriaPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterArticleGetByCriteriaPost$Response(params?: ApiMasterArticleGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Article>>> {
    return apiMasterArticleGetByCriteriaPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleGetByCriteriaPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterArticleGetByCriteriaPost(params?: ApiMasterArticleGetByCriteriaPost$Params, context?: HttpContext): Observable<Array<Article>> {
    return this.apiMasterArticleGetByCriteriaPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Article>>): Array<Article> => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleGetLastThreeGet()` */
  static readonly ApiMasterArticleGetLastThreeGetPath = '/api/Master/Article/GetLastThree';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleGetLastThreeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetLastThreeGet$Response(params?: ApiMasterArticleGetLastThreeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Article>>> {
    return apiMasterArticleGetLastThreeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleGetLastThreeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetLastThreeGet(params?: ApiMasterArticleGetLastThreeGet$Params, context?: HttpContext): Observable<Array<Article>> {
    return this.apiMasterArticleGetLastThreeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Article>>): Array<Article> => r.body)
    );
  }

  /** Path part for operation `apiMasterArticleGetByIdGet()` */
  static readonly ApiMasterArticleGetByIdGetPath = '/api/Master/Article/GetById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterArticleGetByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetByIdGet$Response(params?: ApiMasterArticleGetByIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Article>> {
    return apiMasterArticleGetByIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterArticleGetByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterArticleGetByIdGet(params?: ApiMasterArticleGetByIdGet$Params, context?: HttpContext): Observable<Article> {
    return this.apiMasterArticleGetByIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Article>): Article => r.body)
    );
  }

}
